import type { SyntheticEvent } from 'react';

import type { TActionTrigger, TTrigger } from '../models';

interface IGetTriggers {
    /** Выбранный экшен */
    handleTrigger: TActionTrigger;
    /** Название обработчика события дочернего виджета */
    trigger: TTrigger;
}

/** Получить объект со списком тригеров и их хэндлером */
export const getTriggers = ({ handleTrigger, trigger }: IGetTriggers) => {
    const getTrigger = (key: string) => ({
        [key]: (event?: SyntheticEvent) => handleTrigger({ event, trigger: key }),
    });

    return Array.isArray(trigger)
        ? trigger.reduce(
              (acc, value) => ({
                  ...acc,
                  ...getTrigger(value),
              }),
              {}
          )
        : getTrigger(trigger);
};
